export default __webpack_public_path__ + "static/media/misguided-logo.5000a2be.svg";